module.exports = __webpack_public_path__ + "static/media/video.dafe65d0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/HarleyDykstra/video.mp4
// module id = 261
// module chunks = 0